// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.0
// source: roboverse_platform_protos/statekeeping/Reported/__Common/PowerPolicy.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported.Common";

export interface PowerPolicy {
  /** e.g., 25 means 25% */
  returnHomePower: number;
  /** e.g., 10 means 10% */
  landingPower?: number | undefined;
}

function createBasePowerPolicy(): PowerPolicy {
  return { returnHomePower: 0, landingPower: undefined };
}

export const PowerPolicy: MessageFns<PowerPolicy> = {
  encode(message: PowerPolicy, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.returnHomePower !== 0) {
      writer.uint32(8).int32(message.returnHomePower);
    }
    if (message.landingPower !== undefined) {
      writer.uint32(16).int32(message.landingPower);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PowerPolicy {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePowerPolicy();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.returnHomePower = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.landingPower = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PowerPolicy {
    return {
      returnHomePower: isSet(object.returnHomePower) ? globalThis.Number(object.returnHomePower) : 0,
      landingPower: isSet(object.landingPower) ? globalThis.Number(object.landingPower) : undefined,
    };
  },

  toJSON(message: PowerPolicy): unknown {
    const obj: any = {};
    if (message.returnHomePower !== 0) {
      obj.returnHomePower = Math.round(message.returnHomePower);
    }
    if (message.landingPower !== undefined) {
      obj.landingPower = Math.round(message.landingPower);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PowerPolicy>, I>>(base?: I): PowerPolicy {
    return PowerPolicy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PowerPolicy>, I>>(object: I): PowerPolicy {
    const message = createBasePowerPolicy();
    message.returnHomePower = object.returnHomePower ?? 0;
    message.landingPower = object.landingPower ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
